import { create } from 'zustand'
import type {} from '@redux-devtools/extension' // required for devtools typing
import type { CommonBlockProps } from '../types'

export type RemoteComponentProps = CommonBlockProps & {
  [key: string]: any
}

export type CustomComponentStore = {
  components: Record<string, React.FC<RemoteComponentProps>>
  getCustomComponent: (url: string) => Promise<React.FC<RemoteComponentProps>>
}

export const useCustomComponentStore = create<CustomComponentStore>()((set, get) => ({
  components: {},
  getCustomComponent: async (url) => {
    const cachedComponent = get().components[url]
    if (cachedComponent) {
      return cachedComponent
    }

    const res = await fetch(url).then((res) => res.text())
    const blob = new Blob([res], { type: 'application/javascript' })
    const tmpUrl = URL.createObjectURL(blob)
    const module = await import(/* @vite-ignore */ tmpUrl)
    const component = (() => module.default) as React.FC<RemoteComponentProps>
    set((state) => ({ components: { ...state.components, [url]: component } }))

    return component
  },
}))
